import { FlexVerticalAlign } from "../../../../../base/styles";
import clsx from "clsx";

export const SelectVerticalAlign = ({ title, value, className, onChange }:{
    title: string,
    value?: FlexVerticalAlign,
    className?: string,
    onChange: (value?: FlexVerticalAlign) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as FlexVerticalAlign;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={FlexVerticalAlign.Start}>Start</option>
                <option value={FlexVerticalAlign.End}>End</option>
                <option value={FlexVerticalAlign.Center}>Center</option>
                <option value={FlexVerticalAlign.Baseline}>Baseline</option>
                <option value={FlexVerticalAlign.Stretch}>Stretch</option>
            </select>
        </div>
    )
}